// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🔴 전역(html/body/#root)을 건드리지 않는다 — 2026-08-19 장애.
   여기 있던 \`html, body, #root { height:100%; overflow:hidden }\` 이 **모든 화면**에
   적용돼 tools 메인 화면의 스크롤을 막았다. CRA 는 컴포넌트 CSS 도 전역 스타일시트로
   합치고, \`App.js\` 가 이 페이지를 정적 import 하므로 \`/preview/ox-quiz\` 에 들어가지
   않아도 규칙이 살아 있었다.

   전체화면은 **자기 루트를 뷰포트에 고정**해 얻는다. \`position: fixed\` 는 흐름에서
   빠지므로 body 에 높이를 만들지 않아, 다른 화면의 스크롤에 영향을 주지 않는다.
   회귀 가드: src/globalScrollLock.test.js */
.ox-preview-page {
  position: fixed;
  inset: 0;
  overflow: hidden;
  background: #0b180d;
}

.ox-preview-stage {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.ox-preview-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #f7f2e7;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.ox-preview-state strong {
  font-size: clamp(18px, 2.5vw, 34px);
}

.ox-preview-state span {
  color: rgba(247, 242, 231, 0.72);
  font-size: clamp(13px, 1.4vw, 18px);
}

.ox-preview-launch {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background:
    radial-gradient(circle at 50% 46%, rgba(237, 205, 130, 0.17), transparent 34%),
    #102d16;
  color: #fff8e9;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.ox-preview-launch button {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  padding: 20px 36px;
  border: 2px solid rgba(255, 248, 233, 0.72);
  border-radius: 999px;
  background: #f2a83b;
  color: #17331c;
  font-size: clamp(22px, 3vw, 44px);
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.28);
}

.ox-preview-launch button:active {
  transform: scale(0.98);
}

.ox-preview-launch p {
  margin: 0;
  color: rgba(255, 248, 233, 0.78);
  font-size: clamp(13px, 1.6vw, 22px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/OxQuizPreviewPage.css"],"names":[],"mappings":"AAAA;;;;;;;;wCAQwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sEAAsE;AACxE;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT;;WAES;EACT,cAAc;EACd,sEAAsE;AACxE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,mCAAmC;AACrC","sourcesContent":["/* 🔴 전역(html/body/#root)을 건드리지 않는다 — 2026-08-19 장애.\n   여기 있던 `html, body, #root { height:100%; overflow:hidden }` 이 **모든 화면**에\n   적용돼 tools 메인 화면의 스크롤을 막았다. CRA 는 컴포넌트 CSS 도 전역 스타일시트로\n   합치고, `App.js` 가 이 페이지를 정적 import 하므로 `/preview/ox-quiz` 에 들어가지\n   않아도 규칙이 살아 있었다.\n\n   전체화면은 **자기 루트를 뷰포트에 고정**해 얻는다. `position: fixed` 는 흐름에서\n   빠지므로 body 에 높이를 만들지 않아, 다른 화면의 스크롤에 영향을 주지 않는다.\n   회귀 가드: src/globalScrollLock.test.js */\n.ox-preview-page {\n  position: fixed;\n  inset: 0;\n  overflow: hidden;\n  background: #0b180d;\n}\n\n.ox-preview-stage {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.ox-preview-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 32px;\n  color: #f7f2e7;\n  text-align: center;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.ox-preview-state strong {\n  font-size: clamp(18px, 2.5vw, 34px);\n}\n\n.ox-preview-state span {\n  color: rgba(247, 242, 231, 0.72);\n  font-size: clamp(13px, 1.4vw, 18px);\n}\n\n.ox-preview-launch {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  background:\n    radial-gradient(circle at 50% 46%, rgba(237, 205, 130, 0.17), transparent 34%),\n    #102d16;\n  color: #fff8e9;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.ox-preview-launch button {\n  display: inline-flex;\n  align-items: center;\n  gap: 14px;\n  padding: 20px 36px;\n  border: 2px solid rgba(255, 248, 233, 0.72);\n  border-radius: 999px;\n  background: #f2a83b;\n  color: #17331c;\n  font-size: clamp(22px, 3vw, 44px);\n  font-weight: 800;\n  cursor: pointer;\n  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.28);\n}\n\n.ox-preview-launch button:active {\n  transform: scale(0.98);\n}\n\n.ox-preview-launch p {\n  margin: 0;\n  color: rgba(255, 248, 233, 0.78);\n  font-size: clamp(13px, 1.6vw, 22px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
